import { Helmet } from "react-helmet-async"
import { useTripDetailsOutletContext } from "../_trip-details-context"
import { TripGuests } from "./../../../../../Trips"

export default function TripGuestsPage() {
	const { trip, hasChangesBetweenQuoteAndBookings } =
		useTripDetailsOutletContext()
	return (
		<>
			<Helmet>
				<title>Trip Guests Docs</title>
			</Helmet>
			<TripGuests
				trip={trip}
				disabledSharing={hasChangesBetweenQuoteAndBookings}
			/>
		</>
	)
}
